import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { OfficialCenter } from '../../../../models/OfficialCenter';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-official-center-configuration',
  standalone: true,
  imports: [
    RouterLink,
    GenericCrudComponent
  ],
  templateUrl: './official-center-configuration.component.html',
  styleUrl: './official-center-configuration.component.css'
})
export class OfficialCenterConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'centerName', sort: true },
    { name: 'Nº Registro', active: true, type: 'text', key: 'registration_number', sort: false },
    { name: 'Dígito Control', active: true, type: 'text', key: 'control_number', sort: false },
    { name: 'Tipo', active: true, type: 'text', key: 'type.name', sort: false },
    { name: 'Direccion', active: true, type: 'text', key: 'address', sort: false },
    { name: 'Teléfono', active: true, type: 'text', key: 'phone', sort: false },
    { name: 'Email', active: true, type: 'text', key: 'email', sort: false },
    { name: 'Activo', active: true, type: 'boolean', key: 'active', sort: false },
    { name: 'Descripción', active: true, type: 'text', key: 'description', sort: false },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'centerName', type: 'text', label: 'Nombre del centro oficial', validations: 'required', testValue: 'Centro oficial 1' },
    { name: 'company_id', type: 'select', label: 'Empresa', validations: 'required', url: '/config/company/listOfficialCenterCompanies', singleSelection: true },
    { name: 'nif', type: 'text', label: 'NIF de la empresa', validations: 'required', testValue: 'B12348613' },
    { name: 'registration_number', type: 'text', label: 'Nº Registro', validations: 'required', testValue: '1234' },
    { name: 'control_number', type: 'text', label: 'Dígito Control', validations: 'required', testValue: '1234' },
    { name: 'type_id', type: 'select', label: 'Tipo', validations: 'nullable', url: '/config/official-center-type/list', singleSelection: true },
    { name: 'address', type: 'text', label: 'Calle', colspan: 1, testValue: 'Calle Mayor' },
    { name: 'address_number', type: 'text', label: 'Número', colspan: 1, testValue: '1' },
    { name: 'city', type: 'text', label: 'Localidad', colspan: 1, testValue: 'Alicante' },
    { name: 'province', type: 'text', label: 'Provincia', colspan: 1, testValue: 'Alicante' },
    { name: 'phone', type: 'text', label: 'Teléfono', validations: 'required', testValue: '660066006' },
    { name: 'email', type: 'text', label: 'Email', validations: 'required', testValue: 'test@test.com' },
    { name: 'observations', type: 'textarea', label: 'Observaciones', colspan: 2, testValue: 'Observaciones de prueba del centro oficial' },
    { name: 'active', type: 'boolean-switch', label: 'Activo', validations: 'nullable' },
    { name: 'description', type: 'text', label: 'Descripción', validations: 'nullable', testValue: 'Descripción del centro oficial' },
    { name: 'directors', type: 'select', label: 'Directores', colspan: 1, singleSelection: false, url: '/user/directors' },
    { name: 'teachers', type: 'select', label: 'Profesores', colspan: 1, singleSelection: false, url: '/user/teachers' },
    { name: 'vehicles', type: 'select', label: 'Vehículos', validations: 'nullable', url: '/config/vehicles/listAll', singleSelection: false, labelKey: 'license_plate' },
    { name: 'offices', type: 'select', label: 'Oficina', validations: 'nullable', url: '/config/office/listAll', singleSelection: false },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'centerName', type: 'text', label: 'Nombre del centro oficial', validations: 'required', testValue: 'Centro oficial 1' },
    { name: 'company_id', type: 'select', label: 'Empresa', validations: 'required', url: '/config/company/listOfficialCenterCompanies', singleSelection: true },
    { name: 'nif', type: 'text', label: 'NIF de la empresa', validations: 'required', testValue: 'B12348613' },
    { name: 'registration_number', type: 'text', label: 'Nº Registro', validations: 'required', testValue: '1234' },
    { name: 'control_number', type: 'text', label: 'Dígito Control', validations: 'required', testValue: '1234' },
    { name: 'type_id', type: 'select', label: 'Tipo', url: '/config/official-center-type/list', singleSelection: true },
    { name: 'address', type: 'text', label: 'Calle', colspan: 1 },
    { name: 'address_number', type: 'text', label: 'Número', colspan: 1 },
    { name: 'city', type: 'text', label: 'Localidad', colspan: 1 },
    { name: 'province', type: 'text', label: 'Provincia', colspan: 1 },
    { name: 'phone', type: 'text', label: 'Teléfono', validations: 'required', testValue: '660066006' },
    { name: 'email', type: 'text', label: 'Email', validations: 'required', testValue: 'test@test.com' },
    { name: 'observations', type: 'textarea', label: 'Observaciones', colspan: 2 },
    { name: 'active', type: 'boolean-switch', label: 'Activo', validations: 'nullable' },
    { name: 'description', type: 'text', label: 'Descripción', validations: 'nullable', testValue: 'Descripción del centro oficial' },
    { name: 'directors', type: 'select', label: 'Directores', colspan: 1, singleSelection: false, url: '/user/directors' },
    { name: 'teachers', type: 'select', label: 'Profesores', colspan: 1, singleSelection: false, url: '/user/teachers' },
    { name: 'vehicles', type: 'select', label: 'Vehicule', validations: 'nullable', url: '/config/vehicles/listAll', singleSelection: false, labelKey: 'license_plate' },
    { name: 'offices', type: 'select', label: 'Oficina', validations: 'nullable', url: '/config/office/listAll', singleSelection: false },
  ];


  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'centro oficial',
    createButtonTitle: 'Nuevo Centro Oficial',
    cols: 2,
    createApiSlug: '/config/official-center/store',
    formTitle: 'Crear Centro Oficial',
    formButtonTitle: 'Crear Centro Oficial',
    width: '4xl'
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      // actionSlug: '/config/office/update/{{id}}',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'centro oficial',
        createButtonTitle: '',
        cols: 2,
        originalUpdateApiSlug: '/config/official-center/update/{{id}}',
        createApiSlug: '',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{centerName}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '4xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false,

    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿ Desea eliminar el centro oficial ?',
      deleteRowOnResponse: true,
      actionSlug: '/config/official-center/delete/{{id}}',
    }
  ]

  table: GenericTable<Paginator<OfficialCenter>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/official-center/list',
    paginate: true,
    name: 'centro oficial',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|control_number', operator: 'like', placeholder: 'Nombre o dígito de control' },
    { type: 'multiselect', key: 'type.name', operator: 'in', placeholder: 'Tipo', url: '/config/official-center-type/list', relation_filter_column: 'type_id' },
    { type: 'multiselect', key: 'company.name', operator: 'in', placeholder: 'Sociedad', url: '/config/company/listOfficialCenterCompanies', relation_filter_column: 'company_id' },
    //{type: 'date-between', key: 'created_at', operator: 'between', parsed: "date-arr", placeholder: 'Fecha de creación'},
  ];

  genericCRUD: GenericCRUD<Paginator<OfficialCenter>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: false
  }
}
